import {
  Button,
  CardActions,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  TextFielDecimalNumbers,
} from "../../../../../components";

const ImpostoServicoDialog = ({ open, setOpen, servico }) => {
  const aliquotaProps = {
    margin: "normal",
    variant: "outlined",
    disabled: true,
  };

  return (
    <Dialog
      fullWidth
      maxWidth={"md"}
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <CardHeader
          title="Visualizar Impostos IBS/CBS"
        />
        <Grid container spacing={2} className="mt-1">
          <Grid item xs={4}>
            <TextFielDecimalNumbers
              id="aliquotaIbsUf"
              name="aliquotaIbsUf"
              label="Alíquota IBS UF"
              value={servico?.tributosIbsAliquotaUf ?? ""}
              {...aliquotaProps}
            />
          </Grid>
          <Grid item xs={4}>
            <TextFielDecimalNumbers
              id="aliquotaIbsMun"
              name="aliquotaIbsMun"
              label="Alíquota IBS Municipal"
              value={servico?.tributosIbsAliquotaMun ?? ""}
              {...aliquotaProps}
            />
          </Grid>
          <Grid item xs={4}>
            <TextFielDecimalNumbers
              id="aliquotaIbsCbs"
              name="aliquotaIbsCbs"
              label="Alíquota CBS"
              value={servico?.tributosIbsAliquotaCbs ?? ""}
              {...aliquotaProps}
            />
          </Grid>
          <Grid item xs={4}>
            <TextFielDecimalNumbers
              id="aliquotaIbsRedUf"
              name="aliquotaIbsRedUf"
              label="Alíquota IBS UF Red."
              value={servico?.tributosIbsAliquotaRedUf ?? ""}
              {...aliquotaProps}
            />
          </Grid>
          <Grid item xs={4}>
            <TextFielDecimalNumbers
              id="aliquotaIbsRedMun"
              name="aliquotaIbsRedMun"
              label="Alíquota IBS Municipal Red."
              value={servico?.tributosIbsAliquotaRedMun ?? ""}
              {...aliquotaProps}
            />
          </Grid>
          <Grid item xs={4}>
            <TextFielDecimalNumbers
              id="aliquotaIbsRedCbs"
              name="aliquotaIbsRedCbs"
              label="Alíquota CBS Red."
              value={servico?.tributosIbsAliquotaRedCbs ?? ""}
              {...aliquotaProps}
            />
          </Grid>
        </Grid>
        <CardActions className="d-flex justify-content-end">
          <Button
            variant="contained"
            color="padrao"
            onClick={() => setOpen(false)}
          >
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </DialogContent>
    </Dialog>
  );
};

export default ImpostoServicoDialog;
